import { Component, OnDestroy, QueryList, ViewChildren, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { finalize, takeWhile } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConfigSection } from './sections/config-section';
import { RouteContextService } from '../../../context/services/route-context.service';
import { ProductSpecificServiceProvider } from '@feature/product/services/product-specific-service-provider.service';

@Component({
  selector: 'mojo-mojo-system-settings',
  templateUrl: './mojo-system-settings.component.html'
})
export class MojoSystemSettingsComponent implements AfterViewInit, OnDestroy {

  @ViewChildren('section') configSections: QueryList<ConfigSection<any>>;

  saveInProgress = false;
  alive = true;

  constructor(
    private readonly messageService: ToastrService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly routeContextService: RouteContextService,
    private readonly productServiceProviderService: ProductSpecificServiceProvider) {


  }

  ngAfterViewInit() {
    const observables = this.configSections.map(c => c.load());
    return forkJoin(observables)
      .pipe(
        takeWhile(() => this.alive)
      ).subscribe(
        () => {
          this.changeDetector.markForCheck();
        },
        () => this.messageService.error(
          'An error occurred whilst loading', 'Warning'
        )
      );
  }

  ngOnDestroy() {
    this.alive = false;
  }

  loading(): boolean {
    if (this.configSections == null) return;
    return this.configSections.find(x => x.loading == true) != null;
  }

  canSubmit(): boolean {
    if (this.configSections == null) return;
    return this.configSections.find(x => x.modified && x.valid) != null
      && !this.saveInProgress
      && !this.loading();
  }

  canReset(): boolean {
    if (this.configSections == null) return;
    return !this.saveInProgress && !this.loading();
  }

  submit() {
    this.saveInProgress = true;
    const observables = this.configSections.filter(c => c.modified).map(c => c.submit());
    return forkJoin(observables)
      .pipe(
        takeWhile(() => this.alive),
        finalize(() => this.saveInProgress = false)
    ).subscribe((submissionResults: boolean[]) => {
        if (submissionResults.indexOf(false) > -1) {
          this.messageService.error('System Settings failed to update', 'Changes not saved');
          this.changeDetector.markForCheck();
        } else {
          this.messageService.success('System Settings updated', 'Changes saved');
          this.router.navigate(['/mojo/admin/dashboard']);
        }
      }, () => this.messageService.error(
        'An error occurred, changes not saved', 'Warning'
      ));
  }

  resetForm(): void {
    const product = this.routeContextService.getProductFromRouteData(this.activatedRoute);
    const adminRoute = this.productServiceProviderService.getServiceByProduct(product).adminDashboardRoute;
    this.router.navigate([adminRoute]);
  }
}
